



























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { fileUpload } from "@/constants";
import { CustomerFeedback } from "@/http/api/v2/customerFeedback";

@Component
export default class FeedbackModal extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ required: true }) hotelObjectId!: string;

  type = "inconvenience";
  contents = "";
  fileList: any[] = [];
  noticeKeys: string[] = [];
  submitting = false;

  @Watch("visible")
  resetWhenOpened(value: boolean) {
    if (!value) return;
    this.type = "inconvenience";
    this.contents = "";
    this.fileList = [];
    this.noticeKeys = [];
  }

  async upload({ file, onSuccess, onError }: any) {
    if (this.fileList.length >= 5) {
      onError(new Error("파일은 최대 5개까지 첨부할 수 있습니다."));
      return;
    }
    try {
      onSuccess(await fileUpload(file, 20 * 1024 * 1024));
    } catch (error) {
      this.$message.error("파일 업로드에 실패했습니다.");
      onError(error);
    }
  }

  removeFile(file: any) {
    return true;
  }

  changeFile(event: any) {
    this.fileList = event.fileList.slice(-5);
  }

  async submit() {
    if (!this.contents.trim()) {
      this.$message.warning("의견 내용을 입력해 주세요.");
      return;
    }
    if (!this.hotelObjectId) {
      this.$message.error("호텔 정보를 확인하지 못했습니다. 화면을 새로고침한 후 다시 시도해 주세요.");
      return;
    }
    if (this.fileList.some(item => item.status === "uploading")) {
      this.$message.warning("파일 업로드가 끝날 때까지 잠시 기다려 주세요.");
      return;
    }
    this.submitting = true;
    try {
      await CustomerFeedback.create(this.hotelObjectId, {
        type: this.type,
        contents: this.contents.trim(),
        pageUrl: window.location.href,
        userAgent: navigator.userAgent,
        browserLanguage: navigator.language,
        files: this.fileList
          .map(item => item.response)
          .filter(Boolean),
      });
      this.$message.success("의견이 전달되었습니다. 설정 > 나의 의견에서 확인할 수 있습니다.");
      this.$emit("submitted");
      this.close();
    } catch {
      this.$message.error("의견을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.");
    } finally {
      this.submitting = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
